module.exports = __webpack_public_path__ + "img/ticket.07fdb6b3.png";